export default __webpack_public_path__ + "static/media/alerts-blue.30c87122.svg";